import React, { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import ListItemIcon from '@mui/material/ListItemIcon';

const GeoserverLayersOptions = [
  { label: "Convection (~28km)", value: "CNN_HISTORICAL:EU_025_live_demo" },
  { label: "Convection (~9km)", value: "CNN_HISTORICAL:EU_01_live_demo" },
  // { label: "Convection (~6km)", value: "CNN_HISTORICAL:euro_1k_00625_15m" },
];

const AutocompleteLayersGeoserver = ({ selectedModel, handleModelClick }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    const option = GeoserverLayersOptions.find(o => o.value === selectedModel);
    setSelectedOption(option || null);
  }, [selectedModel]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
      <Autocomplete
        title="Click to select a different ai model"
        options={GeoserverLayersOptions}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        value={selectedOption}
        onChange={(_, newValue) => {
          if (newValue) {
            setSelectedOption(newValue);
            handleModelClick(newValue.value);
          }
        }}
        disableClearable
        forcePopupIcon

        // --- NUEVO: COMPONENTE DE ICONO (INICIALES AM + FLECHA) ---
        popupIcon={
          <>

            <Box
              sx={{
                display: { xs: 'none', sm: 'flex', lg: 'none' },
                color: '#bbb',
                fontSize: '0.65rem',
                fontWeight: 800,
                width: 32,
                height: 22,
                alignItems: 'center',
                justifyContent: 'center',

              }}
            >
              AM
            </Box>

            <Box
              component="span"
              sx={{
                display: { xs: 'flex', sm: 'none', lg: 'flex' },
                alignItems: 'center'
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#bbb">
                <path d="M7 10l5 5 5-5z" />
              </svg>
            </Box>
          </>
        }

        slotProps={{
          popper: {
            sx: {
              width: '350px !important',
              '& .MuiPaper-root': {
                width: '200px !important',
                backgroundColor: 'rgba(20, 20, 20, 0.70)',
                color: '#fff',
                borderRadius: '12px',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.72)',
                backdropFilter: 'blur(4px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                mb: { xs: '0px', md: '40px' },
                ml: { xs: '60px', sm: '0px' },
                userSelect: 'none',
                WebkitUserSelect: 'none',
                '&::before': {
                  content: '"SELECT AI MODEL"',
                  display: { xs: 'none', sm: 'block', lg: 'none' },
                  padding: '12px 16px 8px',
                  fontSize: '0.65rem',
                  fontWeight: 800,
                  color: 'rgba(255,255,255,0.5)',
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
                  marginBottom: '4px'
                }
              },
            },
            modifiers: [{ name: 'offset', options: { offset: [0, 18] } }],
          },
        }}

        ListboxProps={{
          sx: {
            width: '100%',
            py: 0.5,
            '& .MuiAutocomplete-option': {
              gap: '8px',
              py: 0.8,
              whiteSpace: 'nowrap',
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.08)' },
            },
          },
        }}

        renderOption={(props, option, { selected }) => (
          <li {...props} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <ListItemIcon sx={{ minWidth: 32 }}>
              <Radio
                edge="start"
                checked={selected}
                disableRipple
                sx={{ color: '#bbb', '&.Mui-checked': { color: '#4caf50' } }}
              />
            </ListItemIcon>
            <Typography variant="body1" sx={{ color: '#fff', fontSize: '0.85rem', fontWeight: selected ? 700 : 500 }}>
              {option.label}
            </Typography>
          </li>
        )}

        renderInput={(params) => (
          <TextField
            {...params}
            label="AI Model"
            variant="outlined"

            InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
            onMouseDown={(e) => e.preventDefault()}
            inputProps={{
              ...params.inputProps,
              readOnly: true,
              style: {
                cursor: 'pointer',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
              }
            }}
            onFocus={(e) => {
              if (e.target) e.target.scrollLeft = 0;
            }}
            sx={{
              width: 175,
              userSelect: 'none',
              WebkitUserSelect: 'none',
              textAlign: 'center',
              '& .MuiOutlinedInput-root': {
                height: 40,
                cursor: 'pointer',
                backgroundColor: 'rgba(0,0,0,0.35)',
                color: '#fff',
                borderRadius: '12px',
                boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
                backdropFilter: 'blur(2px)',
                alignItems: 'center',


                '& fieldset': { borderColor: '#1976d2' },
                '&:hover fieldset': { borderColor: '#1565c0' },
                '&.Mui-focused fieldset': { borderColor: '#1976d2' },
              },
              '& .MuiInputLabel-root': {
                color: 'rgba(255,255,255,0.9)',
                fontSize: '0.8rem',
                pointerEvents: 'none',
                '&.Mui-focused': { color: '#ffffff' }
              },
              '& .MuiInputBase-input': {
                color: '#fff',
                py: 0,
                fontSize: '0.85rem',
                pointerEvents: 'none',
                userSelect: 'none',
                textOverflow: 'ellipsis',
                '&::selection': { backgroundColor: 'transparent' }
              },

              '& .MuiAutocomplete-endAdornment': {
                marginRight: { xs: '0px', sm: '0px', md: '12px', lg: '0px' },
                marginLeft: '5px',
                '& .MuiAutocomplete-popupIndicator': {
                  transform: 'none !important',
                  '&.MuiAutocomplete-popupIndicatorOpen': { transform: 'none !important' }
                }
              }
            }}
          />
        )}
        sx={{ width: 190, mt: '10px', cursor: 'pointer' }}
      />
    </Box>
  );
};

export default AutocompleteLayersGeoserver;
